// extracted by css-extract-rspack-plugin
export default {"cls1":"StatelessWorkCardsUpsellModal-styles-cls1_IJe","cls2":"StatelessWorkCardsUpsellModal-styles-cls2_GUA StatelessWorkCardsUpsellModal-styles-cls1_IJe"};